import React from "react";
import {Route, Navigate, RouteProps} from "react-router-dom";

import {APICore} from "../helpers/api/apiCore";

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRoute = ({children, permissions, ...rest}: any) => {
    const api = new APICore();
    if (!api.isUserAuthenticated()) {
        // not logged in so redirect to login page with the return url
        return (
            <Navigate
                // state={from: props['path']}
                to={{
                    pathname: "/auth/login",
                    // state: { from: props['path'] },
                }}
            />
        );
    }

    const loggedInUser = api.getLoggedInUser();
    // check if route is restricted by role
    if (permissions && !permissions?.some((item: string) => loggedInUser?.permission?.includes(item))) {
        // role not authorised so redirect to login page
        return <Navigate to={{pathname: "/"}}/>;
    }

    return <>{children}</>;
};

export default PrivateRoute;
